export default __webpack_public_path__ + "static/media/arrow.06934016.svg";